var DisassociateVendorsModalController = /** @class */ (function () {
    function DisassociateVendorsModalController() {
        // this.buVendorsInfo = this.resolve.buVendorsInfo;
        // this.note = this.resolve.note;
        // this.context = this.resolve.context;
    }
    DisassociateVendorsModalController.prototype.$onInit = function () {
        this.buVendorsInfo = this.resolve.buVendorsInfo;
        this.note = this.resolve.note;
        this.context = this.resolve.context;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    };
    DisassociateVendorsModalController.prototype.onDisassociateVendors = function (note) {
        this.callbackObject = { callbackType: 'disassociate', entity: { note: note } };
        this.closeModal();
    };
    DisassociateVendorsModalController.prototype.closeModal = function () {
        this.modalInstance.close(this.callbackObject);
    };
    DisassociateVendorsModalController.prototype.dismissModal = function () {
        this.modalInstance.dismiss('cancel');
    };
    return DisassociateVendorsModalController;
}());
// import * as TEMPLATE from './disassociate-vendors-modal.html';
import * as TEMPLATE from 'raw-loader!./disassociate-vendors-modal.html';
export var DisassociateVendorsModalComponent = {
    selector: 'disassociateVendorsModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: DisassociateVendorsModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/company/disassociateVendorsModal/disassociate-vendors-modal.html'
    }
};
//# sourceMappingURL=dissassociate-vendors-modal.component.js.map